<script setup>
const { isWidget } = useWidgetSettings()

function shouldShowNavMenu({ navMenuItems, activeItem }) {
  const visibleInactiveNavMenuItems = navMenuItems.filter(item => item.visible && item !== activeItem)
  return visibleInactiveNavMenuItems.length
}
</script>

<template>
  <AppNavMenuItemsProvider v-slot="{ navMenuItems, activeItem, visibleItemsCount }">
    <DSStacked
      v-slot="{ isFixed }"
      group="header-nav-stacking-group"
      teleport-target="#sticky-container"
      position="static"
      :rank="1"
      :enabled="isWidget && visibleItemsCount > 1"
    >
      <nav
        v-if="isWidget || shouldShowNavMenu({ navMenuItems, activeItem })"
        class="app-nav-menu--wrapper flex lt-sm:!hidden"
        :class="{ 'mx--4': isFixed }"
      >
        <MainContainer class="flex grow">
          <ul
            class="app-nav-menu-items mx-4 flex grow flex-wrap justify-start gap-2 border-1 border-surface-600 rounded p-2 !bg-[--theme-color-nav-background]"
          >
            <template v-if="shouldShowNavMenu({ navMenuItems, activeItem })">
              <template
                v-for="(item, itemIndex) in navMenuItems"
                :key="itemIndex"
              >
                <li v-if="item.visible">
                  <AppNavMenuItem
                    v-if="item?.label || item?.icon"
                    v-bind="{ ...item, active: item === activeItem }"
                  />
                </li>
              </template>
            </template>
            <AppLoginOrLogoutButton
              v-if="isWidget"
              class="lt-md:ms-0 md:ms-auto"
            />
          </ul>
        </MainContainer>
      </nav>
    </DSStacked>
  </AppNavMenuItemsProvider>
</template>

<style lang="scss" scoped>
:deep(.action) {
  @apply border-1 border-secondary-400 text-secondary-400 rounded lt-sm:(border-0 flex w-100%);
}
</style>

<i18n lang="json" locale="en-us">
{
  "Log Out": "Log Out"
}
</i18n>

<i18n locale="de" lang="json">
{
  "Log Out": "Abmelden"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Log Out": "Se déconnecter"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Log Out": "Finalizar sesión"
}
</i18n>
